import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCmsMetaData } from "../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../Components/Utility/setMetaTags";

function ThankYou() {
  const location = useLocation();
  const navigate = useNavigate();
  const thankyouData = JSON.parse(sessionStorage.getItem("thankyouBooking"));
  const booking = location.state || thankyouData;
  const [meta, setMeta] = useState();

  // console.log("thankyou", thankyouData);
  // console.log("booking", booking);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("thankyou");
      setMeta(data);
    };

    loadMeta();
  }, []);

  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = ((hour + 11) % 12) + 1;
    return `${hour12}:${minutes} ${suffix}`;
  };

  // Convert "Date2025-10-28 | 14:28:00 - 15:28:00" → "Date2025-10-28 | 2:28 PM - 3:28 PM"
  const formatBookingDateTime = (rawDate) => {
    if (!rawDate) return "";

    // Split into date and time parts
    const [datePart, timePart] = rawDate.split("|");
    if (!timePart) return rawDate;

    const [start, end] = timePart.trim().split("-");
    const startTime = formatTimeTo12Hour(start.trim().replace(":", ":"));
    const endTime = formatTimeTo12Hour(end.trim().replace(":", ":"));

    return `${datePart.trim()} | ${startTime} - ${endTime}`;
  };

  // If no data (like direct access), redirect back to home or checkout
  if (!booking) {
    navigate("/");
    return null;
  }

  const getExperienceUrl = (slug) => {
    return `/experience/${slug}`;
  };

  return (
    <>
      {/* <!-- Confirm and pay --> */}
      <section className="ser_v_araeea detailspgess checkout thnkyou">
        <SetMetaTags
          title={meta?.meta_title || "Thanyou | Weyfarin"}
          description={meta?.meta_description || "Thanyou | Weyfarin"}
        />
        <div className="container">
          <div className="top_bk_areaa">
            {/* <a
              onClick={() => navigate(-1)}
              className="ar_left"
              style={{ cursor: "pointer" }}
            >
              <img src="images/chevron-left.png" alt="" />
            </a> */}
            <h3>Thanks for booking an experience with us!</h3>
            <p>Looking forward to deliver you the priceless experience</p>
          </div>

          <div className="nw_cheekly_rmd">
            <h3>Cheeky reminder: </h3>
            <p>
              your adventure doesn’t end here—your confirmation email’s got that
              sweet stay promo code to complete the whole experience 😉
            </p>
          </div>

          <div className="row">
            {/* Left Section */}

            <div className="col-lg-12">
              <div className="chek_bx_txt">
                <div className="meddils">
                  <div
                    className="mg_arease"
                    onClick={() =>
                      navigate(
                        getExperienceUrl(
                          booking?.slug
                        ),
                      )
                    }
                  >
                    <img
                      src={booking.experienceImage}
                      alt={booking.experienceName}
                    />
                  </div>
                  <div className="dtls_rightss tetx_arease">
                    <h3
                      onClick={() =>
                        navigate(
                          getExperienceUrl(
                            booking?.slug
                          ),
                        )
                      }
                    >
                      {booking.experienceName}
                    </h3>
                    <div className="us_listst">
                      <ul>
                        <li>
                          <i className="fa fa-star"></i> {booking.rating}/5
                        </li>
                        <li
                          className={
                            booking.reviews > 0 ? "" : "platforma_cursor"
                          }
                          onClick={() => {
                            if (booking.reviews > 0) {
                              navigate(
                                getExperienceUrl(
                                  booking?.slug
                                ),
                              );
                            }
                          }}
                        >
                          {booking.reviews} reviews
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="ck_ckalsinss thyou">
                <h2>Experience Details</h2>
                <div className="clk_liststs">
                  <h4>Date & Time Slot</h4>
                  {/* <p>{booking.date}</p> */}
                  <p>{formatBookingDateTime(booking.date)}</p>
                </div>

                <div className="clk_liststs">
                  <h4>Guests</h4>
                  <p>
                    {booking.guests}
                    <span className="thankyou_price">{booking?.price}</span>
                  </p>

                  {booking?.discount && booking?.coupon_code && (
                    <div className="d-flex justify-content-between text-success mt-2 coupon-discount-price">
                      <span>
                        Discount{" "}
                        {booking?.coupon_code ? `(${booking.coupon_code})` : ""}
                      </span>
                      <span>{booking?.discount}</span>
                    </div>
                  )}
                </div>

                <div className="clk_liststs">
                  <h4>
                    Total <span className="lst">{booking.total}</span>
                  </h4>

                  {booking?.discount && booking?.coupon_code && (
                    <div className="mt-2 text-center rounded coupons-grandtotal">
                      You're saving {booking?.discount}!
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-lg-6">
              <div className="ck_ckalsinss thyou">
                <h2>Booking Details</h2>
                <div className="clk_liststs">
                  <h4>Booking ID</h4>
                  <p>{booking.bookingId}</p>
                </div>

                <div className="clk_liststs">
                  <h4>Transaction Mode</h4>
                  <p>{booking.transactionMode}</p>
                </div>

                <div className="clk_liststs">
                  <h4>Transaction ID</h4>
                  <p>{booking.transactionId}</p>
                </div>
              </div>
            </div>

            {/* Bottom Button */}
            <div className="col-lg-12">
              <div className="buttons mt_space">
                <a
                  onClick={() => navigate("/")}
                  className="links"
                  style={{ cursor: "pointer" }}
                >
                  Explore more experiences
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Confirm and pay --> */}
    </>
  );
}

export default ThankYou;
